/**
 * Router / API route configuration.
 * API version and route base path used by the router and navigation.
 */

/** API version segment for route paths (e.g. 'v0' → base is '/api/v0'). */
export const apiVersion = 'v0'

/** Base path for app routes. Override apiVersion to change. */
export const routeBase = `/api/${apiVersion}`
